/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as moment from "moment-timezone";
import { getTimezoneMetadata } from "./timezoneMetadata";
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var TimezoneDisplayFormat = {
    /** Abbreviation format: `"HST"` */
    ABBREVIATION: "abbreviation",
    /** Composite format: `"Pacific/Honolulu (HST) -10:00"` */
    COMPOSITE: "composite",
    /** Name format: `"Pacific/Honolulu"` */
    NAME: "name",
    /** Offset format: `"-10:00"` */
    OFFSET: "offset",
};
export function formatTimezone(timezone, date, displayFormat) {
    if (!timezone || !moment.tz.zone(timezone)) {
        return undefined;
    }
    var _a = getTimezoneMetadata(timezone, date), abbreviation = _a.abbreviation, offsetAsString = _a.offsetAsString;
    switch (displayFormat) {
        case TimezoneDisplayFormat.ABBREVIATION:
            // Fall back to the offset when there is no abbreviation.
            return abbreviation !== undefined ? abbreviation : offsetAsString;
        case TimezoneDisplayFormat.NAME:
            return timezone;
        case TimezoneDisplayFormat.OFFSET:
            return offsetAsString;
        case TimezoneDisplayFormat.COMPOSITE:
            return "" + timezone + (abbreviation ? " (" + abbreviation + ")" : "") + " " + offsetAsString;
    }
}
//# sourceMappingURL=timezoneDisplayFormat.js.map